import React, { useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiArrowUpRight, FiShield } from "react-icons/fi";
import { sendContactEmail } from "../emailService";

const initialFormData = {
  user_name: "",
  user_company: "",
  user_phone: "",
  user_email: "",
  user_project: "",
};

function FormHeroSection() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const form = useRef();

  const handleForm = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      await sendContactEmail(form.current);
      toast.success("Your request has been sent successfully!", {
        position: "top-right",
        autoClose: 2000,
        theme: "light",
      });
      setFormData(initialFormData);
    } catch (error) {
      console.error("EmailJS submission failed:", error);
      toast.error("We couldn't send your request. Please try again.", {
        position: "top-right",
        autoClose: 2500,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <aside
      id="hero-contact"
      className="hero-form"
      aria-labelledby="hero-form-title"
    >
      <ToastContainer newestOnTop closeOnClick pauseOnHover theme="light" />

      <div className="hero-form__heading">
        <p>Let's Talk About Your Business</p>
        <h2 id="hero-form-title">Ready to Transform Your Business with Dynamics 365?</h2>
        <span>
          Tell us about your business requirements, and our team will help you find the right Microsoft Dynamics 365 Business Central solution.
        </span>
      </div>

      <form ref={form} onSubmit={handleSubmit} className="hero-form__fields">
        <div className="hero-form__row">
          <label>
            Your Name
            <input
              name="user_name"
              required
              type="text"
              autoComplete="name"
              value={formData.user_name}
              onChange={handleForm}
              placeholder="Enter your full name"
            />
          </label>
          <label>
            Company Name
            <input
              name="user_company"
              required
              type="text"
              autoComplete="organization"
              value={formData.user_company}
              onChange={handleForm}
              placeholder="Enter your company name"
            />
          </label>
        </div>

        <div className="hero-form__row">
          <label>
            Phone Number
            <input
              type="tel"
              name="user_phone"
              autoComplete="tel"
              value={formData.user_phone}
              onChange={handleForm}
              pattern="[0-9]{10}"
              required
              title="Please enter a valid 10-digit phone number"
              placeholder="10-digit mobile number"
            />
          </label>
          <label>
            Business Email
            <input
              type="email"
              name="user_email"
              autoComplete="email"
              required
              value={formData.user_email}
              onChange={handleForm}
              placeholder="you@company.com"
            />
          </label>
        </div>

        <label>
          How Can We Help?
          <textarea
            name="user_project"
            value={formData.user_project}
            onChange={handleForm}
            placeholder="Tell us about your business requirements, implementation needs, customization, integration, or support requirements."
            rows="3"
            required
          />
        </label>

        <button className="hero-form__submit" type="submit" disabled={loading}>
          {loading ? "Sending your request…" : "Book a Discovery Call"}
          {!loading && <FiArrowUpRight aria-hidden="true" />}
        </button>
      </form>

      <p className="hero-form__privacy">
        <FiShield aria-hidden="true" /> Your details stay private. No spam, ever.
      </p>
    </aside>
  );
}

export default FormHeroSection;
